module.exports = __webpack_public_path__ + "img/wagb-screen-1.bbd589cd.webp";